"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const moment = require("moment");
const _ = require("lodash");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
const AdFormBanner_1 = require("@dialogexe/cw-component-adform/AdFormBanner");
const events_1 = require("@dialogexe/cw-website-store/events");
const cw_component_title_1 = require("@dialogexe/cw-component-title");
const DatePicker_1 = require("@dialogexe/cw-component-date-picker/DatePicker");
const ProgramItem_1 = require("./ProgramItem");
const Spinner_1 = require("./Spinner");
const marked_ts_1 = require("marked-ts");
require("moment/locale/nn");
require("moment/locale/nb");
class Program extends React.Component {
    constructor(props) {
        super(props);
        this.groupedEvents = [];
        this.state = {
            active: {
                date: '',
                events: []
            },
            showSpinner: true,
            days: [],
            selectedCategory: null
        };
        this.extractAndGroupEvents = (events) => {
            this
                .sortEventsTickets(this.props.events)
                .forEach(event => {
                this.filterEventTickets(event)
                    .forEach(ticket => {
                    const existingEvent = this.groupedEvents.find(e => e.id === event.id && e.tickets.findIndex(t => moment(t.date).isSame(moment(ticket.date), 'day')) !== -1);
                    if (existingEvent) {
                        existingEvent.tickets.push(ticket);
                        return;
                    }
                    const eventCopy = _.cloneDeep(event);
                    eventCopy.date = ticket.date;
                    eventCopy.tickets = [];
                    eventCopy.tickets.push(ticket);
                    this.groupedEvents.push(eventCopy);
                });
            });
            const days = this.groupedEvents.reduce((days, next) => {
                if (days.length && days.find(d => moment(next.date).isSame(d.date, 'day'))) {
                    return days;
                }
                if (this.isBetweenFilterDates(next.date)) {
                    days.push({
                        date: next.date
                    });
                }
                return days;
            }, []).sort((a, b) => moment(a.date).unix() - moment(b.date).unix());
            if (days.length === 0) {
                return this.setState({ showSpinner: false });
            }
            const activeDay = days[0];
            this.setState({
                days
            }, () => { this.setActiveDay(activeDay, () => this.setState({ showSpinner: false })); });
        };
        this.isBetweenFilterDates = (date) => {
            if (!moment(date).isValid()) {
                return false;
            }
            const period = moment(date).startOf('day');
            const { fromDate, toDate } = this.getDate();
            return period.isBetween(moment(fromDate).startOf('day'), moment(toDate).startOf('day'), null, '[]');
        };
        this.createMarkup = (content) => {
            return { __html: content };
        };
        this.noEventsMessages = () => {
            const { preferredLanguage } = this.props;
            return preferredLanguage === 'nn'
                ? 'Me har for tida ingen forestillingar i programmet. Fleire vil bli lagt til seinare.'
                : 'Vi har for tiden ingen forestillinger i programmet. Flere vil bli lagt til senere.';
        };
        this.translateToNyNorsk = (value) => {
            switch (value) {
                case 'Konserter':
                    return 'Konsertar';
                case 'Annet':
                    return 'Anna';
                case 'konferanser':
                    return 'konferansar';
                case 'Foredrag/konferanser':
                    return 'Foredrag/konferansar';
                default:
                    return value;
            }
        };
        this.setActiveDay = (day, callback) => {
            if (!day) {
                callback();
                return;
            }
            this.setState({
                active: {
                    date: day.date,
                    events: this.groupedEvents.filter(e => {
                        return moment(e.date).isSame(day.date, 'day');
                    })
                },
            }, callback);
        };
        this.getDate = () => {
            const { from, to } = this.props.filter;
            let fromDate = moment();
            let toDate = moment().add(2, 'years');
            if (from && from.trim() !== "") {
                fromDate = from;
            }
            if (to && to.trim() !== "") {
                toDate = to;
            }
            return {
                fromDate: moment(fromDate, 'YYYY-MM-DD'),
                toDate: moment(toDate, 'YYYY-MM-DD')
            };
        };
        const preferredLanguage = props.preferredLanguage ? props.preferredLanguage : 'nb';
        moment.locale(preferredLanguage);
        marked_ts_1.Marked.setOptions({
            gfm: true,
            tables: true,
            breaks: false,
            pedantic: false,
            sanitize: false,
            smartLists: true,
            smartypants: false
        });
    }
    componentDidMount() {
        let ids = [];
        this.props.events.forEach(e => { ids = ids.concat(e.tickets.map(t => t.id)); });
        this.props.eventActions.fetchEvents(ids);
        if (this.props.filter && this.props.filter.type === 'category') {
            return this.setState({ showSpinner: false });
        }
        this.extractAndGroupEvents(this.props.events);
    }
    componentWillReceiveProps(nextProps) {
        this.groupedEvents = [];
        this.extractAndGroupEvents(nextProps.events);
    }
    render() {
        if (this.state.showSpinner) {
            return (React.createElement("div", { className: "level is-center" },
                React.createElement(Spinner_1.Spinner, null)));
        }
        const { title, subtitle, filter, bannerId, bannerMobileId, adFlagsFilter } = this.props;
        const markedContent = marked_ts_1.Marked.parse(subtitle);
        return (React.createElement("div", { className: "Program" },
            title && (React.createElement(cw_component_title_1.default, { text: title })),
            subtitle && (React.createElement("div", { className: "subtitle" },
                React.createElement("div", { dangerouslySetInnerHTML: this.createMarkup(markedContent) }))),
            this.renderFilter(),
            this.renderEvents()));
    }
    renderEvents() {
        const { title, subtitle, filter, bannerId, bannerMobileId, adFlagsFilter, preferredLanguage, events } = this.props;
        let existingEvents = this.getFilteredEvents(events);
        existingEvents = this.sortEventsByTicketStartDate(existingEvents);
        if (existingEvents.length === 0) {
            return (React.createElement("div", { className: "level is-center" },
                React.createElement("h2", null,
                    " ",
                    this.noEventsMessages(),
                    " ")));
        }
        return (React.createElement("div", { className: "events" }, existingEvents.map((event, index) => (React.createElement("div", { key: index, className: "event-item" },
            React.createElement(ProgramItem_1.ProgramItem, { image: event.image, title: event.title, subtitle: this.formatSubtitle(event), description: event.description, cast: event.cast, link: event.link, features: event.features, properties: event.properties, tickets: this.filterEventTickets(event), ticketDisplayMode: this.props.ticketDisplayMode, showFullDate: filter && filter.type === 'category' || event.type === 'movie_coming' || adFlagsFilter.length > 0, club: event.club, preferredLanguage: preferredLanguage }),
            index === 1 && (React.createElement(AdFormBanner_1.default, { id: bannerId, mobileId: bannerMobileId })))))));
    }
    hasFromOrToDateFilter() {
        if (this.props.filter) {
            return Boolean(this.props.filter.from) || Boolean(this.props.filter.to);
        }
        return false;
    }
    ;
    renderFilter() {
        const { active, days } = this.state;
        const { events, preferredLanguage } = this.props;
        const { selectedCategory } = this.state;
        const filter = this.props.filter && this.props.filter.type.trim();
        const hasFromOrToDateFilter = this.hasFromOrToDateFilter();
        const categories = this.getDistinctCategories();
        if (filter === 'category') {
            if (categories.length <= 1) {
                return (React.createElement("div", null));
            }
            return (React.createElement("nav", { className: "filter" },
                React.createElement("div", { className: "tabs is-hidden-mobile" },
                    React.createElement("a", { href: "#", className: `tab ${selectedCategory === null ? 'is-active' : ''}`, onClick: (e) => { e.preventDefault(); this.onCategorySelect.bind(this)(null); } }, "Alle"),
                    categories.map((category, i) => (React.createElement("a", { key: i, href: "#", className: `tab ${category === selectedCategory ? 'is-active' : ''}`, onClick: (e) => { e.preventDefault(); this.onCategorySelect.bind(this)(category); } }, preferredLanguage === 'nn' ? this.translateToNyNorsk(category) : category)))),
                React.createElement("div", { className: "input is-wide is-hidden-tablet" },
                    React.createElement("select", { onChange: (e) => {
                            e.target.value === '' ?
                                this.setState({ selectedCategory: null }) :
                                this.setState({ selectedCategory: e.target.value });
                        } },
                        React.createElement("option", { value: "" }, "Alle"),
                        categories.map((category, i) => (React.createElement("option", { value: category, key: i }, preferredLanguage === 'nn' ? this.translateToNyNorsk(category) : category)))),
                    React.createElement("i", null,
                        React.createElement("img", { src: icons_1.arrowheadDownIcon, alt: "" })))));
        }
        if (filter === 'date' && (!hasFromOrToDateFilter || this.state.days.length > 1)) {
            return (React.createElement("div", { className: "filter-show" },
                this.renderDatePicker(),
                this.renderDropDown()));
        }
        return React.createElement("div", null);
    }
    renderDatePicker() {
        const { preferredLanguage } = this.props;
        const { active, days, } = this.state;
        const thePreferredLanguage = preferredLanguage ? preferredLanguage : 'nb';
        return (React.createElement(DatePicker_1.DatePicker, { days: days, active: active, setActiveDay: this.setActiveDay, preferredLanguage: thePreferredLanguage }));
    }
    renderDropDown() {
        return (React.createElement("nav", { className: "drop-down-filter" },
            React.createElement("div", { className: "input is-wide" },
                React.createElement("select", { onChange: this.onDaySelected.bind(this), value: this.state.active.date }, this.state.days.map((day, index) => (React.createElement("option", { key: index, value: day.date }, moment(day.date).format('dddd DD. MMMM YYYY'))))),
                React.createElement("i", null,
                    React.createElement("img", { src: icons_1.arrowheadDownIcon, alt: "" })))));
    }
    onDaySelected(e) {
        this.setActiveDay({
            date: e.target.value
        });
    }
    getDistinctCategories() {
        const { events } = this.props;
        let categories = {};
        events.forEach(event => {
            categories[event.category] = '';
        });
        return Object.keys(categories);
    }
    getFilteredEvents(events) {
        const { filter } = this.props;
        const { active, selectedCategory } = this.state;
        if (filter && filter.type === 'date') {
            return events
                .filter((e) => active.events.some((aa) => aa.id === e.id))
                .map((event) => {
                const activeEvent = active.events.find(a => a.id === event.id);
                return {
                    ...event,
                    tickets: activeEvent.tickets.filter((t) => moment(t.date).isSame(moment(active.date), "day")),
                };
            });
        }
        if (filter && filter.type === 'category') {
            const filtered = events
                .filter((event) => (selectedCategory === null || event.category === selectedCategory))
                .sort((e1, e2) => moment(e1.begin).unix() - moment(e2.begin).unix());
            return this.sortEventsTickets(filtered);
        }
        const filtered = events
            .sort((e1, e2) => moment(e1.begin).unix() - moment(e2.begin).unix());
        return this.sortEventsTickets(filtered);
    }
    sortEventsByTicketStartDate(events) {
        return events.sort((e1, e2) => {
            const e1Tickets = this.sortEventTicketsByStartDate(this.filterEventTickets(e1));
            const e2Tickets = this.sortEventTicketsByStartDate(this.filterEventTickets(e2));
            const e1FirstTicketDate = e1Tickets.length > 0 ? e1Tickets[0].date : null;
            const e2FirstTicketDate = e2Tickets.length > 0 ? e2Tickets[0].date : null;
            if (!e1FirstTicketDate && !e2FirstTicketDate) {
                return 0;
            }
            else if (e1FirstTicketDate && !e2FirstTicketDate) {
                return -1;
            }
            else if (!e1FirstTicketDate && e2FirstTicketDate) {
                return 1;
            }
            return moment(e1FirstTicketDate).unix() - moment(e2FirstTicketDate).unix();
        });
    }
    filterEventTickets(event) {
        const { adFlagsFilter } = this.props;
        const eventWithValidTickets = {
            ...event,
            tickets: event.tickets
                .filter(ticket => moment(ticket.date).startOf('day').isSameOrAfter(moment(Date.now()).startOf('day')))
        };
        if (adFlagsFilter.length === 0) {
            return eventWithValidTickets.tickets.filter(ticket => ticket.link || ticket.location || ticket.purchaseUrl);
        }
        return eventWithValidTickets.tickets
            .filter(ticket => (adFlagsFilter.some(adFlag => (ticket.adFlags.indexOf(adFlag) !== -1) && (ticket.link || ticket.location || ticket.purchaseUrl))));
    }
    sortEventsTickets(events) {
        const masterProductions = this.getGroupedEvents(events);
        return masterProductions.map(event => {
            event.tickets = this.sortEventTicketsByStartDate(event.tickets);
            return event;
        });
    }
    /* Group event with different version of production and gather tickets in one event */
    getGroupedEvents(events) {
        let eventsWithMasterProductions = [];
        events.forEach((event) => {
            const existingEvent = eventsWithMasterProductions.find(e => e.link && e.link === event.link);
            if (existingEvent) {
                const filterOut = eventsWithMasterProductions.filter(pro => pro.link != event.link);
                eventsWithMasterProductions = [...filterOut, { ...existingEvent, tickets: [...event.tickets, ...existingEvent.tickets] }];
            }
            else {
                eventsWithMasterProductions.push(event);
            }
        });
        return eventsWithMasterProductions;
    }
    sortEventTicketsByStartDate(tickets) {
        return tickets.sort((a, b) => moment(a.date).unix() - moment(b.date).unix());
    }
    formatSubtitle(event) {
        return event.type === 'movie_coming' ? 'Premiere ' + moment(event.begin).format('ll') : '';
    }
    onCategorySelect(category) {
        this.setState({
            selectedCategory: category,
        });
    }
}
exports.Program = Program;
function merge(newEvents, currentEvents) {
    if (newEvents.length === 0) {
        const result = currentEvents.map(ce => {
            const tickets = ce.tickets.map(ticket => {
                return { ...ticket, features: ce.features };
            });
            return { ...ce, tickets: tickets };
        });
        return result;
    }
    return currentEvents.map(e => {
        e.tickets = e.tickets.map(t => {
            const newTicket = newEvents.find(ne => ne.key === t.id);
            if (!newTicket) {
                return t;
            }
            t.count = newTicket.ticket_left_count;
            t.countLow = newTicket.almost_sold_out;
            t.salesEnabled = newTicket.ticket_sales_enabled;
            t.salesActive = newTicket.ticket_sales_active;
            t.ticketSaleWebEndDate = newTicket.ticket_sales_end;
            t.purchaseUrl = newTicket.purchase_url;
            t.ticketSaleWebStartDateRealTime = newTicket.ticket_sales_begin;
            t.features = e.features;
            return t;
        });
        return e;
    });
}
exports.default = react_redux_1.connect((state, ownProps) => ({
    events: merge(state.events.items, ownProps.events)
}), (dispatch) => ({
    eventActions: redux_1.bindActionCreators(events_1.actionCreators, dispatch)
}))(Program);



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-program/Program.tsx